import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTheme } from '../../core/contexts/ThemeContext';
interface BootSequenceProps {
  onComplete: () => void;
}
export function BootSequence({
  onComplete
}: BootSequenceProps) {
  const {
    t
  } = useTheme();
  const [progress, setProgress] = useState(0);
  const [statusIndex, setStatusIndex] = useState(0);
  const statuses = [t('boot.loading'), t('boot.design_systems'), t('boot.connecting_ai'), t('boot.ready')];
  useEffect(() => {
    const duration = 2500;
    const interval = 20;
    const step = 100 / (duration / interval);
    const timer = setInterval(() => {
      setProgress(prev => {
        const next = prev + step;
        if (next >= 100) {
          clearInterval(timer);
          setTimeout(onComplete, 300);
          return 100;
        }
        return next;
      });
    }, interval);
    return () => clearInterval(timer);
  }, [onComplete]);
  useEffect(() => {
    const statusDuration = 2500 / statuses.length;
    const statusTimer = setInterval(() => {
      setStatusIndex(prev => Math.min(prev + 1, statuses.length - 1));
    }, statusDuration);
    return () => clearInterval(statusTimer);
  }, [statuses.length]);
  return <motion.div initial={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeInOut'
  }} className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#0F0F0F]" data-id="element-161" data-mp="15aopdyeuzexp">
      <div className="flex flex-col items-center gap-8 w-full max-w-xs px-6" data-id="element-162" data-mp="hjj9jj8x4mne">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center gap-3" data-id="element-163" data-mp="mgj4oz48c4zq">
          <h1 className="text-3xl md:text-4xl font-medium text-[#E8E8E6] tracking-tight m-0" data-id="element-164" data-mp="2u2xdqnmts6r">
            MvlCreative
          </h1>
          <span className="font-mono text-xs text-[#9B9B9B] tracking-widest uppercase" data-id="element-165" data-mp="3u1774tb5vsiv">
            MvlCreative OS v2.0
          </span>
        </motion.div>

        {/* Progress bar */}
        <div className="w-full space-y-4" data-id="element-166" data-mp="6v6gqn4w26cq">
          <div className="h-px w-full bg-white/10 overflow-hidden" data-id="element-167" data-mp="6whhee31exzm">
            <motion.div className="h-full bg-[#C8956C]" style={{
            width: `${progress}%`
          }} transition={{
            duration: 0.05
          }} data-id="element-168" data-mp="3fcjbyo589ktg" />
          </div>

          <div className="h-4 flex justify-center overflow-hidden" data-id="element-169" data-mp="3p35ilsuyv100">
            <AnimatePresence mode="wait" data-id="element-170" data-mp="3k91ah69ysmxc">
              <motion.span key={statusIndex} initial={{
              opacity: 0,
              y: 5
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -5
            }} transition={{
              duration: 0.2
            }} className="font-mono text-[10px] text-[#6B6B6B] uppercase tracking-widest" data-id="element-171" data-mp="2wkqi6ric3vko">
                {statuses[statusIndex]}
              </motion.span>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </motion.div>;
}